import { connect } from "react-redux"
import { frameImageDropped, selectFrameClip, updateSwapHoverDrop, setPropertyWindow, updateTransformStatus } from "../../actions";
import DroppableAreasComponent from "../../components/Frame/DroppableAreasComponent";

const mapStateToProps = (state, ownProps) => ({
    selectedScene: state.localStore.get("selectedScene"),
    selectedItemId: state.localStore.getIn(["selectedItems", 0]),
    selectedItem:
        state.localStore.get("selectedItems").size === 1
        ? state.project.getIn([
            "scenes", state.localStore.get("selectedScene"), "workspaceItems",
            state.localStore.getIn(["selectedItems", 0])
        ])
        : undefined,
    isFraming: state.localStore.get("isFraming"),
    transformStatus: state.localStore.getIn(["transformStatus"]),
    isLibraryItemDragging: state.localStore.get("isLibraryItemDragging"),
    libraryImageDrag: state.localStore.get("libraryImageDrag"),
    swapHoverDrop: state.localStore.get("swapHoverDrop"),
    selectedFrameClip: state.localStore.get("selectedFrameClip"),
    propertyWindow: state.localStore.get("propertyWindow"),
    isPlay: state.localStore.get("isPlay"),
    isPlayAll: state.localStore.get("isPlayAll"),
});

const mapDispatchToProps = (dispatch, ownProps) => ({
    // selectFrameClip: (data) => dispatch(selectFrameClip(data)),
    // frameImageDropped: (data, socket) => dispatch(frameImageDropped(data, socket)),
    // updateSwapHoverDrop: (data) => dispatch(updateSwapHoverDrop(data)),
    // setPropertyWindow: (data) => dispatch(setPropertyWindow(data)),
    // updateTransformStatus: (data) => dispatch(updateTransformStatus(data)),
});

const DroppableAreas = connect(
    mapStateToProps,
    mapDispatchToProps
)(DroppableAreasComponent)
  
export default DroppableAreas;


// WEBPACK FOOTER //
// ./src/containers/Frame/DroppableAreas.js